export default "__VITE_ASSET__Bwrh$jCO__"